module.exports = __webpack_public_path__ + "img/Monte_Kope_117.275ecd60.jpg";